import React, { FC } from 'react';
import { makeStyles } from '@material-ui/styles';
import { LinkProps } from 'next/dist/client/link';
import { PageLink } from "components/common/atoms";

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 6,
    height: 50,
    padding: '0 16px',
    verticalAlign: 'middle',
    textDecoration: 'none',
    cursor: 'pointer',
    userSelect: 'none',
    fontWeight: 600,
    color: '#f6f8f9',
    transition: 'all 0.15s ease-in-out',
    background: '#F9C106',
  },
}));

const E5LinkButton: FC<LinkProps> = (props) => {
  const classes = useStyles();
  const { children, href } = props;

  return (
    <PageLink className={classes.root} href={String(href)}>
      {children}
    </PageLink>
  );
};

export default E5LinkButton;
